import * as Animate from "react-reveal";

const principles = [
  {
    number: "01",
    title: "Hit heavy, stay small",
    desc: "Small teams stay close to the work and move with purpose.",
    tint: false,
  },
  {
    number: "02",
    title: "Open communication",
    desc: "Clear, honest conversations make the product and the team stronger.",
    tint: true,
  },
  {
    number: "03",
    title: "Autonomy and attitude",
    desc: "Own your decisions, bring energy and ask for help when you need it.",
    tint: true,
  },
  {
    number: "04",
    title: "Support and win",
    desc:
      "We share context, celebrate progress and help one another get better.",
    tint: false,
  },
];

const CareerHowWeWorkSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-3 gap-5">
        <div className="">
          <Animate.Fade bottom>
            <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
              <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
              How we work
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black mb-12 lg:mb-14 max-w-xl tracking-[-0.03em] text-primary">
              High ambition. Human scale.
            </h2>
          </Animate.Fade>
        </div>

        <div className="sm:col-span-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {principles.map((item) => (
              <Animate.Fade bottom key={item.number}>
                <article
                  className="h-full rounded-2xl p-7"
                  style={{ background: item.tint ? "#fdf2df" : "#ffffff" }}
                >
                  <span className="text-[#8e5e00] font-poppins text-xs font-extrabold">
                    {item.number}
                  </span>
                  <h3 className="font-poppins font-extrabold text-xl text-primary mt-10 mb-2.5">
                    {item.title}
                  </h3>
                  <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                    {item.desc}
                  </p>
                </article>
              </Animate.Fade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerHowWeWorkSection;
